import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { HomeDomainCard } from './HomeDomainCard';

const HomeDomainConfig = [
  {
    label: 'Expertise & Conseil',
    src: 'expertise-conseil',
    text_1:'• Stratégie et Business Plan',
    text_2: '• Etudes sectorielles et analyse de cible',
    text_3: '• Audit et Etudes d’opportunité ',
    text_4: '• Aide au choix et Cadrage ...',
  },
  {
    label: 'Direction de projet',
    src: 'direction-projet',
    text_1:
      '• Structure organisationnelle ' ,
      text_2: '• Etudes sectorielles et analyse de cible',
      text_3: '• Optimisation de la performance et Gestion des processus ',
      text_4: '• Pilotage de programme ou projet et PMO ...',
    },
  {
    label: 'Gestion de projet IT',
    src: 'gestion-projet-it',
    text_1:
      '• Gouvernance SI et cadrage ',
      text_2: '• Urbanisation et schéma directeur',
      text_3: '• Maîtrise d’ouvrage MOA et AMOA ',
      text_4: '• Recette et formation ...',
    },
  {
    label: 'Transformation digitale',
    src: 'transformation-digitale',
    text_1:
      '• Stratégie Digitale ',
      text_2: '• Digitalisation des processus',
      text_3: '• Big Data et Data Marketing  ',
      text_4: '• Mobilité et Cloud',
    },
  {
    label: 'Formation/Coaching',
    src: 'formation-coaching',
    text_1:
      '• Coaching individuel et équipes ',
      text_2: '• Conseil en communication',
      text_3: '• Accompagnement professionel ... ',
      text_4: '',
    },
  {
    label: 'Audit RH/SIRH',
    src: 'audit-rh-sirh',
    text_1:
      '• Audit des organisations ',
      text_2: '• Transformation RH ',
      text_3: '• Digitalisation du recrutement ',
      text_4: '• RSE, social media & community management ...',
    },
];

export const HomeDomain = () => (
  <section>
    <Row className='pt-3 '>
      <Col xs='12' className='pt-3'>
        <h2 className='text-center'>
          Domaines <strong className='text-warning'>d'intervention</strong>
        </h2>
      </Col>
    </Row>
    <Container className=' p-3 pt-4' >
      <Row className=''>
        {HomeDomainConfig.map((config, key: number) => (
          <HomeDomainCard
            key={key}
            label={config.label}
            text_1={config.text_1}
            text_2={config.text_2}
            text_3={config.text_3}
            text_4={config.text_4}
            src={config.src}
          />
        ))}
      </Row>
    </Container>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/HomePage/HomeDomain/HomeDomain.tsx